import {
    AlignItems,
    Column,
    Container,
    Gap,
    Gutter,
    Row,
    RowCols,
    Stack,
    StackDirection,
    Text,
    Wrapper
} from "@rebootui";

import Icon from "../common/Icon";

const features = [
    { icon: "access", text: "Accessible by default" },
    { icon: "responsive", text: "Fully responsive" },
    { icon: "shine", text: "Bootstrap-powered" },
    { icon: "color", text: "Customizable with CSS" },
    { icon: "code", text: "Consistent structure" },
    { icon: "light", text: "Easy integration" },
];

const Features = () => {
    return (
        <section className="py-md-7 py-6">
            <Container>
                <Stack direction={StackDirection.Column} gap={Gap.Gap5}>
                    <Wrapper className="text-center">
                        <Text className="h2 mb-3">
                            Simple, Developer-Friendly API
                        </Text>
                        <Text className="fs-5 mb-0 text-secondary">
                            Clean and predictable components designed for scalability and
                            consistency.
                        </Text>
                    </Wrapper>
                    <Row cols={[RowCols.RowColsLg3, RowCols.RowColsSm2, RowCols.RowCols1]} gutter={Gutter.G4} className="px-lg-5">
                        {features.map((feature, index) => (
                            <Column key={index}>
                                <Stack alignItems={AlignItems.Center} gap={Gap.Gap3} className="border border-black border-dark-hover border-opacity-10 border-opacity-40-hover rounded-4 shadow-m-hover tr-base hover-scale-icon p-m">
                                    <Stack.Item className="icon bg-black bg-opacity-5 text-dark p-s rounded-4">
                                        <Icon name={feature.icon} width={24} height={24} />
                                    </Stack.Item>
                                    <Text el="p" className="mb-0 text-dark">{feature.text}</Text>
                                </Stack>
                            </Column>
                        ))}
                    </Row>
                    {/* <Stack direction={StackDirection.Column} gap={Gap.Gap3} className="text-start bg-dark p-5 rounded-5">
                        <Stack.Item>
                            <Stack direction={StackDirection.Row} gap={Gap.Gap3}>
                                <Stack.Item className="text-danger">
                                    <Icon name="bullet" width={12} height={12} />
                                </Stack.Item>
                                <Stack.Item className="text-warning">
                                    <Icon name="bullet" width={12} height={12} />
                                </Stack.Item>
                                <Stack.Item className="text-success">
                                    <Icon name="bullet" width={12} height={12} />
                                </Stack.Item>
                            </Stack>
                        </Stack.Item>
                        <Stack.Item>
                            <Text el="pre" className="text-white">
                                <code>
                                    import {"{"} Button, Card {"}"} from '@reactufy/rebootui';
                                    {"\n"}function App() {"{"}
                                    {"\n"}
                                    {"  "}return ({"\n"}
                                    {"    "}&lt;Card&gt;{"\n"}
                                    {"      "}&lt;Button variant="primary"&gt;{"\n"}
                                    {"        "}Get Started{"\n"}
                                    {"      "}&lt;/Button&gt;{"\n"}
                                    {"    "}&lt;/Card&gt;{"\n"}
                                    {"  "});{"\n"}
                                    {"}"}
                                    {"\n"}
                                    &lt;link href="rebootui.css"&gt;
                                </code>
                            </Text>
                        </Stack.Item>
                    </Stack> */}
                </Stack>
            </Container>
        </section>
    );
};

export default Features;
